import { useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";

// Lien marketing tracké : /r/{code}. Compte le clic, mémorise le code partenaire,
// puis redirige vers la page d'inscription avec ?ref={code}.
export default function PartnerRedirect() {
  const { code } = useParams();
  const nav = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const c = (code || "").trim();
    if (!c) { nav("/", { replace: true }); return; }
    try { sessionStorage.setItem("aca_ref", c); } catch {}
    api.post("/partners/track", { code: c })
      .catch(() => {})
      .finally(() => nav(`/inscription?ref=${encodeURIComponent(c)}`, { replace: true }));
  }, [code, nav]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-void" data-testid="partner-redirect">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-cyan border-t-transparent" />
      <p className="text-sm text-ink-secondary">Redirection vers l'inscription…</p>
    </div>
  );
}
